module.exports = __webpack_public_path__ + "img/pic9.0d1604a0.jpg";